import { EditRuleSetState } from "../hooks/use-edit-ruleset";

type EditRuleSetActionsProps = {
  state: EditRuleSetState;
};

const EditRuleSetActions = (props: EditRuleSetActionsProps) => {
  const editRulesetState: EditRuleSetState = props.state;
  return (
    <div className="flex w-full mx-4 md:mx-36 justify-end items-center gap-4 mb-8">
      <button
        onClick={(e) => {
          e.preventDefault();
          editRulesetState.cancel();
        }}
        className="w-36 inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
      >
        Cancel
      </button>
      <button
        type="submit"
        disabled={
          !editRulesetState.formState.isValid ||
          editRulesetState.formState.isSubmitting ||
          !editRulesetState.currentRules ||
          editRulesetState.currentRules.length <= 0
        }
        className={`${
          !editRulesetState.formState.isValid ||
          editRulesetState.formState.isSubmitting ||
          !editRulesetState.currentRules ||
          editRulesetState.currentRules.length <= 0
            ? "opacity-40 cursor-not-allowed"
            : ""
        } w-36 inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500`}
      >
        Save
      </button>
    </div>
  );
};

export default EditRuleSetActions;
